import type { AppFeatures } from "./types";

export const hasFileUploadAccess = (features: AppFeatures): boolean => {
  return features.fileUploadAccess === true;
};

export const hasVoiceAccess = (features: AppFeatures): boolean => {
  return features.voiceAccess === true;
};
